/**
 * @enum {string}
 */
var _ol_webgl_ContextEventType_ = {
  LOST: 'webglcontextlost',
  RESTORED: 'webglcontextrestored'
};

export default _ol_webgl_ContextEventType_;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ol/webgl/contexteventtype.js
// module id = ../../../../ol/webgl/contexteventtype.js
// module chunks = vendor